var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 28,
    viewBox: "0 0 16 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4268 5.20161C13.3576 5.09241 14.2988 5.07161 15.37 5.00401C15.37 3.75081 15.3804 2.24281 15.3492 0.974013C15.3492 0.974013 15.0944 0.927212 14.9384 0.901212C13.186 0.651612 11.4284 0.396813 9.67604 0.838813C7.01364 1.51481 5.36004 3.63121 5.30284 6.45481C5.27164 7.87441 5.29764 9.29401 5.29764 10.8384C4.16404 10.8384 2.15684 10.8488 0.97644 10.8176C1.01284 12.1748 0.997241 14.3796 0.997241 15.7316H5.23004V27.3952L10.5236 27.3796V15.7576C11.4752 15.7576 13.3576 15.7472 14.4548 15.7836C14.4548 15.7628 14.4548 15.742 14.4548 15.716C14.6212 14.3692 14.9332 12.3204 15.1464 10.8696H10.3936C10.4924 9.39801 10.4976 8.00961 10.7056 6.65761C10.846 5.81001 11.5584 5.30561 12.4268 5.20161Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace);
export default __webpack_public_path__ + "static/media/face.9202ac4934346819d7d87b0003d0424a.svg";
export { ForwardRef as ReactComponent };